module.exports = [
	{
		"start": 0.13,
		"text": "My parents decided to bring us here because there was an economic collapse in Peru and it was very difficult for any of my family members to find jobs."
	},
	{
		"start": 7.5,
		"text": "I arrived to the United States when I was 8 years old. Once I got to college, being undocumented was no longer a fear."
	},
	{
		"start": 14.07,
		"text": "It was a frustration. Whenever I would visit a career fair, there were anywhere from 200 to 300 companies, and"
	},
	{
		"start": 21.15,
		"text": "not a single one of them could hire me. So it was this push and pull factor."
	},
	{
		"start": 26.38,
		"text": "Push from my parents to succeed, to be everything that they wanted me to be."
	},
	{
		"start": 31.159,
		"text": "But seeing in the future the impossibility of it all because, even if I did every single thing correctly and got a perfect GPA, I would still be undocumented."
	},
	{
		"start": 42.48,
		"text": "When DACA came along, I was in the middle of summer school in my junior year of college."
	},
	{
		"start": 48.08,
		"text": "I had just finished a final exam in the morning and I had taken a Megabus all the way back to Houston and I was tired, exhausted."
	},
	{
		"start": 54.82,
		"text": "And as soon as I arrived to the bus station, I saw my dad and he ran to me. He grabbed my stuff, he gave me a big hug."
	},
	{
		"start": 60.5,
		"text": "He was telling me about this announcement that Obama had given. \"Son, you're finally going to be able to do it,\" he was telling me."
	},
	{
		"start": 66.909,
		"text": "\"You're finally going to be able to work! All of our patience has paid off!"
	},
	{
		"start": 70.84,
		"text": "You're going to be able to do everything that we wanted you to do, that we hoped that you could do!\""
	},
	{
		"start": 75.24,
		"text": "I applied literally a week after the application came out. And when my work permit finally came in, I was just ecstatic."
	},
	{
		"start": 82.25,
		"text": "Now I work for an oil and gas company here in Houston, Texas, called Schlumberger."
	},
	{
		"start": 88.189,
		"text": "They told me that they would do everything in their power to keep me by transferring me to a location outside of the United States."
	},
	{
		"start": 95.28,
		"text": "And, after a year, then they'd be able to apply for an L-1 visa for me to be able to come back."
	},
	{
		"start": 101.76,
		"text": "DACA was never enough,  because DACA just gave some 800,000 kids the ability to work, the ability to do so much. But there's 11 million of us."
	},
	{
		"start": 112.479,
		"text": "I'm thinking of the people that are in worse positions than I am in, like my parents. Their income is still less than mine."
	},
	{
		"start": 119.719,
		"text": "And that frustrated me so much, that they've worked most of their life, 12 hour shifts, and that they could still be making so little."
	},
	{
		"start": 128.66,
		"text": "If I don't have DACA then I can't get them out of those jobs, I can't help them out."
	},
	{
		"start": 133.22,
		"text": "It would be like taking two steps back when we took one step forward."
	}
];


//////////////////
// WEBPACK FOOTER
// ../assets/transcripts/javier.json
// module id = 8
// module chunks = 0